export const apiVersionPrefix: string = "/api/v1";

export const flightApiPrefix: string = `${apiVersionPrefix}/flight`;
export const disruptionsApiPrefix: string = `${flightApiPrefix}/disruptions`;
export const disruptionsExerciseApiPrefix: string = `${disruptionsApiPrefix}/exercise`;
export const getFlightDisruptionExerciseEligibilityPath: string = `${disruptionsExerciseApiPrefix}/eligibility`;
